/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const HidePasswordIcon = ({ fill = "#686868 " }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.32675 22.4987C11.0282 23.3778 12.9538 23.875 14.9996 23.875C20.3737 23.875 24.9184 20.4438 26.7501 15.6719L27.008 15L26.7501 14.3281C25.9374 12.2109 24.5907 10.3577 22.8745 8.95094L21.5412 10.2842C23.0733 11.4957 24.2789 13.1224 24.9996 15C23.4269 19.0973 19.545 22 14.9996 22C13.4827 22 12.0397 21.6767 10.7317 21.0937L9.32675 22.4987ZM9.03326 20.1405C7.22736 18.8976 5.80824 17.1067 4.99959 15C6.57232 10.9027 10.4541 8 14.9996 8C16.781 8 18.4605 8.44585 19.939 9.23472L21.3157 7.8581C19.4628 6.7579 17.3077 6.125 14.9996 6.125C9.62549 6.125 5.08078 9.55618 3.24912 14.3281L2.99121 15L3.24912 15.6719C4.14877 18.0157 5.70295 20.0361 7.68845 21.4853L9.03326 20.1405Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8702 17.9556C14.2211 18.0899 14.602 18.1634 15.0002 18.1634C16.7472 18.1634 18.1634 16.7472 18.1634 15.0002C18.1634 14.602 18.0899 14.2211 17.9556 13.8702L13.8702 17.9556ZM16.7856 12.3886C16.2774 12.0405 15.6626 11.8369 15.0002 11.8369C13.2531 11.8369 11.8369 13.2531 11.8369 15.0002C11.8369 15.6626 12.0405 16.2774 12.3886 16.7856L16.7856 12.3886Z"
      fill={fill}
    />
    <path
      d="M25.6904 7.24512L7.19043 25.7451"
      stroke={fill}
      strokeWidth="1.875"
    />
  </svg>
);
export default HidePasswordIcon;
